module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-viewer",
    style: (_vm.styleObjs)
  }, [(_vm.images && _vm.images.length > 0) ? _c('div', {
    staticClass: "container-number-seal-img"
  }, [(_vm.isPdf) ? _c('div', {
    class: {
      'img-wrapper': true,
      'pdf-wrapper': _vm.isPdf
    },
    style: (_vm.imgWrapperStyle)
  }, _vm._l((_vm.images), function(url, index) {
    return _c('iframe', {
      key: index,
      class: {
        active: index === _vm.activeIndex
      },
      staticStyle: {
        "width": "100%",
        "heigth": "auto"
      },
      attrs: {
        "src": url,
        "frameborder": "0"
      }
    }, [_vm._v("1")])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.isPdf) ? _c('div', {
    directives: [{
      name: "drag",
      rawName: "v-drag"
    }],
    ref: "imgWrapper",
    staticClass: "img-wrapper",
    style: (_vm.imgWrapperStyle)
  }, _vm._l((_vm.images), function(img, index) {
    return _c('img', {
      key: index,
      class: {
        active: index === _vm.activeIndex
      },
      style: (_vm.imgStyle),
      attrs: {
        "src": img.imagePath
      }
    })
  }), 0) : _vm._e()]) : _c('div', {
    staticClass: "clear container-number-seal-img",
    staticStyle: {
      "line-height": "400px"
    }
  }, [_vm._v("无上传照片")]), _vm._v(" "), _c('div', {
    staticClass: "clear container-number-seal-bar"
  }, [(_vm.showDownload) ? _c('a', {
    staticClass: "download",
    on: {
      "click": _vm.downloadAttachment
    }
  }, [_c('img', {
    attrs: {
      "src": require("../images/icon-download.png"),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.images.length > 1) ? _c('i', {
    staticClass: "ivu-icon ivu-icon-chevron-left",
    on: {
      "click": _vm.prevImage
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "ivu-icon ivu-icon-plus-round",
    on: {
      "click": _vm.enlargeImage
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "ivu-icon ivu-icon-minus-round",
    on: {
      "click": _vm.shrinkImage
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "ivu-icon ivu-icon-refresh",
    on: {
      "click": _vm.rotateImage
    }
  }), _vm._v(" "), (_vm.images.length > 1) ? _c('i', {
    staticClass: "ivu-icon ivu-icon-chevron-right",
    on: {
      "click": _vm.nextImage
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "container-sequence",
    domProps: {
      "textContent": _vm._s(_vm.activeIndex + 1)
    }
  }), _vm._v(" "), _c('span', [_vm._v(" / ")]), _vm._v(" "), (_vm.images) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.images.length)
    }
  }) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-090d7491", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-090d7491"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/components/image-viewer.vue
// module id = 1348
// module chunks = 61